(function ($, Drupal, once) {
  Drupal.behaviors.embedVideo = {
    attach: function (context) {

      once(
          'embed-video',
          '.paragraph--type--embed-video-with-thumbnail .video-container',
          context
      ).forEach(function (container) {

        const iframe = container.querySelector('iframe');
        const player = new Vimeo.Player(iframe);

        $(container).find('.play-icon').on('click', function () {

          $(container)
          .find('.field--name-field-image, .play-icon')
          .fadeOut(200);

          player.play();
        });
      });
    }
  };
})(jQuery, Drupal, once);